import 'd3-format'
import * as d3 from 'd3'
import SingleDataViewerComponent from '../../common/SingleDataViewer/SingleDataViewerComponent'
import PropTypes from 'prop-types'

const AffectedPopulation = ({
  state,
  sampleSize,
  loadingAggregations,
  outreachSimulationTitle = '',
  percentage = ''
}) => {
  AffectedPopulation.propTypes = {
    state: PropTypes.string,
    sampleSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    loadingAggregations: PropTypes.bool,
    outreachSimulationTitle: PropTypes.string,
    percentage: PropTypes.string
  }
  const title = outreachSimulationTitle || `Selected ${state} Adult Population`
  function getSampleSize() {
    if (typeof sampleSize === 'string') {
      return sampleSize
    }
    return sampleSize >= 0 ? d3.format('.4~s')(sampleSize) : '---'
  }

  return (
    <SingleDataViewerComponent
      text={title}
      value={getSampleSize()}
      loading={loadingAggregations}
      percent={percentage}
    />
  )
}

export default AffectedPopulation
